import styled, { css } from 'styled-components';
import {
  StyledTableCell,
  StyledTableRow as DataTableRow
} from 'components/DataTable/style';
import { MLAApplicationStatus, MLASyncStatus } from '../../hooks/useGetMLAApplicationList';

const baseActionButton = css`
  ${({ theme }) => css`
    ${theme.typography.Body2};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 6px;
    padding: ${theme.spacing.s1} ${theme.spacing.s2};
    line-height: 20px;
    white-space: nowrap;
    cursor: pointer;
    font: inherit;
    text-align: center;
    color: ${theme.palette.N700};

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`;

export const Style = {
  TableRow: styled(DataTableRow)<{ $status: MLAApplicationStatus }>(({ theme, $status }) => css`
    ${StyledTableCell} {
      ${$status === MLAApplicationStatus.Reject &&
      `background-color: ${theme.palette.R50};`}
      ${$status === MLAApplicationStatus.Approve &&
      `background-color: ${theme.palette.G50};`}
    }

    &:nth-of-type(even) {
      ${StyledTableCell} {
        ${$status === MLAApplicationStatus.Reject &&
        `background-color: ${theme.palette.R50};`}
        ${$status === MLAApplicationStatus.Approve &&
        `background-color: ${theme.palette.G50};`}
      }
    }
  `),
  ReviewStatusContent: styled('span')(() => css`
    display: inline-flex;
    align-items: center;
    gap: 8px;
  `),
  StatusCircle: styled('svg')<{ status: MLAApplicationStatus }>(({ theme, status }) => css`
    display: block;
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    ${status === MLAApplicationStatus.Approve && `color: ${theme.palette.G400}`};
    ${status === MLAApplicationStatus.Pending && `color: ${theme.palette.N450}`};
    ${status === MLAApplicationStatus.Reject && `color: ${theme.palette.R400}`};
  `),
  ReviewButton: styled('button')(({ theme }) => css`
    ${baseActionButton};
    background-color: ${theme.palette.P400};
  `),
  ReviewedText: styled('span')(({ theme }) => css`
    ${theme.typography.Body2};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing.s1} ${theme.spacing.s2};
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
  `),
  RetryButton: styled('button')(({ theme }) => css`
    ${baseActionButton};
    background-color: ${theme.palette.ACYPrimaryMainLight};
  `),
  AccountStatus: styled('span')<{ $syncStatus: MLASyncStatus }>(({ theme, $syncStatus }) => css`
    white-space: nowrap;
    color: ${theme.palette.N50};
    ${$syncStatus === 'SYNCED' && `color: ${theme.palette.P500}`};
    ${$syncStatus === 'PENDING_SYNC' && `color: ${theme.palette.ACYPrimaryMainLight}`};
    ${$syncStatus === 'SYNC_FAILED' && `color: ${theme.palette.R400}`};
  `)
};
